import React, { useEffect, useRef } from 'react';

import {
  registerVariantMount,
  unregisterVariantMount,
  type TranslateVariant,
} from './googleTranslateLoader';

import './style.scss';

interface GoogleTranslateWidgetProps {
  variant?: TranslateVariant;
}

export function GoogleTranslateWidget({ variant = 'desktop' }: GoogleTranslateWidgetProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    registerVariantMount(variant, container);

    return () => {
      unregisterVariantMount(variant, container);
    };
  }, [variant]);

  return <div className="google-translate-widget" ref={containerRef} />;
}
